import './kowNav.scss'
import { useStore } from '@/store'
import { download } from '@/utils'
import { useCallback, useMemo } from 'react'
import { checkPlayer } from '@/request/utils'
import { useMaxWidth } from '@/hooks/useMaxWidth'
import { clickReport } from '@app/report'
import { getDefaultZone$ } from '@/request/userServer'
import logo from '@app/assets/img/logo.png'
import jaLogo from '@app/assets/img/ja-logo.png'
import koLogo from '@app/assets/img/ko-logo.png'
import zhTWLogo from '@app/assets/img/zh-TW-logo.png'

export default function KowNav() {
  const { state, dispatch } = useStore()
  const zoneId = state.login.userInfo.zoneId
  const lang = state.login.userInfo.lang
  const { width, safeAreaTop } = useMaxWidth()
  const widthStyle = useMemo(() => {
    // maxWidth: `${width}px`
    const style = { top: `${safeAreaTop}px` }
    return style
  }, [width, safeAreaTop])
  const dynamicLogo = useMemo(() => {
    switch (lang) {
      case 'ja':
        return jaLogo
      case 'ko':
        return koLogo
      case 'zh-TW':
      case 'zh-CN':
        return zhTWLogo

      default:
        return logo
    }
  }, [lang])

  const openRuleModal = () => {
    clickReport('rule')
    dispatch({
      type: 'updateModal',
      data: {
        ruleOpen: true,
      },
    })
  }

  const openRecordModal = async () => {
    if (!(await checkPlayer('record'))) return

    clickReport('record')
    dispatch({
      type: 'updateModal',
      data: {
        recordOpen: true,
      },
    })
  }

  const showAccountInfo = async () => {
    clickReport('accout')
    await checkPlayer('account')
  }

  const _download = useCallback(() => {
    clickReport('download')
    if (zoneId === 0) {
      return getDefaultZone$.then((id) => download(id))
    }
    download(zoneId)
  }, [zoneId])

  return (
    <div className="kow-nav" style={widthStyle}>
      <a className="kow-nav__item kow-nav__item--goback"></a>
      <a
        className="kow-nav__item kow-nav__item--download"
        onClick={_download}
      ></a>
      <div className="kow-nav__placer"></div>
      <div className="logo">
        <img src={dynamicLogo} alt=" " />
      </div>
      <a
        className="kow-nav__item kow-nav__item--account"
        onClick={showAccountInfo}
      ></a>
      <a
        className="kow-nav__item kow-nav__item--rule"
        onClick={openRuleModal}
      ></a>
      <a
        className="kow-nav__item kow-nav__item--records"
        onClick={openRecordModal}
      ></a>
    </div>
  )
}
